<style lang="less">
    @import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="monitoring">
        <div class="container">
            <div class="monitoring_box" style="margin-top:20px">
                <div class="monitoring_box_left">
                    <div class="photo_box">
                        <div class="title_group">
                            <div class="">
                                <span>监测中</span>
                                <span class="subheading">监测完成后可在个人中心查看监测历史</span>
                            </div>
                            <router-link class="gray_btn" :to="'/monitor?id='+monitorId">新增监测</router-link>
                        </div>

                        <div class="photo_main">
                            <div class="fan_chart">
                                <!--              监测平台              -->
                                <div class="tips_box platform">
                                    <span class="tips_name">监测平台</span>
                                    <span>{{platfromNumber}}个</span>
                                </div>

                                <!--             监测数据               -->
                                <div class="tips_box data">
                                    <span class="tips_name">已监测数据</span>
                                    <span>{{monitorNumber}}条</span>
                                </div>

                                <!--             监测状态               -->
                                <div class="tips_box time">
                                    <div v-if="monitorState == 2">
                                        <img class="monitor_complete" src="./images/monitor_complete.png" alt="">
                                        <span>监测已完成</span>
                                    </div>

                                    <div v-else>
                                        <img class="rotate_loading" src="./images/monitoring.png" alt="">
                                        <span>正在监测中…</span>
                                    </div>


                                </div>

                                <div class="circular">{{ spreadNumber }}</div>
                                <p class="circular_desc">监测结果数量</p>
                            </div>
                        </div>

                        <div class="btn_group">
                            <a :href="reportUrl" v-if="monitorState == 2 && reportUrl && reportUrl!='' "
                               class="btn_big">下载监测报告</a>
                        </div>
                    </div>

                    <div v-if="platforms.length!=0" class="result_box">
                        <div class="result_main">
                            <div class="title_group">
                                <div class="">
                                    <span>监测结果：发现{{ platformsTotal }}个平台上有传播数据</span>
                                </div>
                                <router-link :to=" '/monitorDetails?id=' + monitorId " class="gray_btn"
                                             style="width: 90px;height: 33px;line-height: 33px;">查看监测详情
                                </router-link>
                            </div>

                            <div class="result_group">
                                <Row class="table-style-size">
                                    <i-col span="8">平台</i-col>
                                    <i-col span="8">传播数量</i-col>
                                    <i-col span="8">监测数量</i-col>
                                </Row>

                                <Row v-for="(item,index) in platforms" class="table-style-size table-style-body"
                                     style="height:65px">
                                    <i-col span="8">{{ item.title }}</i-col>
                                    <!--                                    <i-col span="8">{{ item.spreadNumber }}条</i-col>-->
                                    <i-col span="8">
                                        <countTo :startVal='item.spreadNumberStart ? item.spreadNumberStart-0 : 0'
                                                 :endVal='item.spreadNumber-0'
                                                 :duration='500'/>
                                        条
                                    </i-col>
                                    <i-col span="8">
                                        <countTo :startVal='item.monitorNumberStart ? item.monitorNumberStart-0 : 0'
                                                 :endVal='item.monitorNumber-0'
                                                 :duration='500'/>
                                        条
                                    </i-col>

                                </Row>
                                <!--                                <div>查看更多</div>-->
                            </div>
                        </div>

                    </div>

                    <div v-if="monitorData.length!=0" class="partial_result_box">
                        <div class="partial_result_main">
                            <div class="title_group">
                                <div class="">
                                    <span>部分监测结果</span>
                                </div>
                            </div>

                            <ul class="partial_result_group">
                                <monitorItem v-for="(item,index) in monitorData" :data="item"
                                             class="result_item"></monitorItem>
                            </ul>
                        </div>
                    </div>

                    <div class="legal_introduction">
                        <div class="legal_introduction_title">
                            <p>发现侵权怎么办</p>
                            <p>版权家提供版权法律服务</p>
                        </div>

                        <ul class="legal_introduction_group">
                            <li class="legal_introduction_item">
                                <div class="legal_introduction_item_title">
                                    <div class="item_title_num">01</div>
                                    <div class="item_title_desc">
                                        <span class="desc_msg">STEP ONE</span>
                                    </div>
                                </div>
                                <p>解答版权侵权中的法律问题，梳理证据</p>
                            </li>
                            <li class="legal_introduction_item">
                                <div class="legal_introduction_item_title">
                                    <div class="item_title_num">02</div>
                                    <div class="item_title_desc">
                                        <span class="desc_msg">STEP TWO</span>
                                    </div>
                                </div>
                                <p>进行区块链司法存证，直通互联网法院</p>
                            </li>
                            <li class="legal_introduction_item">
                                <div class="legal_introduction_item_title">
                                    <div class="item_title_num">03</div>
                                    <div class="item_title_desc">
                                        <span class="desc_msg">STEP THREE</span>
                                    </div>
                                </div>
                                <p>律师参与整个侵权过程，进行指导</p>
                            </li>
                            <li class="legal_introduction_item">
                                <div class="legal_introduction_item_title">
                                    <div class="item_title_num">04</div>
                                    <div class="item_title_desc">
                                        <span class="desc_msg">STEP FOUR</span>
                                    </div>
                                </div>
                                <p>出席法庭进行庭审</p>
                            </li>
                            <li class="legal_introduction_item">
                                <div class="legal_introduction_item_title">
                                    <div class="item_title_num">05</div>
                                    <div class="item_title_desc">
                                        <span class="desc_msg">STEP FIVE</span>
                                    </div>
                                </div>
                                <p>出具专业律师函等相关文件</p>
                            </li>
                        </ul>

                        <div class="legal_introduction_btn">
                            <router-link to="/lawTelephone" class="btn_big">咨询律师</router-link>
                            <router-link to="/copyrightEvidence" class="btn_big bigBtn">司法存证(证据固定)</router-link>
                        </div>

                    </div>
                </div>
                <div class="monitoring_box_right">
                    <div class="monitoring_content_box">
                        <div class="monitoring_content_title">监测内容</div>
                        <div class="monitoring_content_msg">
                            <div class="monitoring_content_msg_img_box">
                                <img v-if="workImage" class="monitoring_content_msg_img" :src="workImage" alt="">
                                <img v-else class="partial_result_img_icon"
                                     :src="monitorType == 'word' ? textIcon : monitorType == 'music' ? musicIcon : fileIcon  "
                                     alt="">
                            </div>
                            <ul class="monitoring_content_group">
                                <li class="monitoring_content_item">
                                    <span>监测类型：</span>
                                    <div class="item_content">{{ monitorType == 'image' ? '图片' : monitorType == 'music'
                                        ? '音乐' : monitorType == 'word' ? '文字' :'' }}
                                    </div>
                                </li>
                                <li class="monitoring_content_item">
                                    <span>监测名称：</span>
                                    <div class="item_content">{{ monitorName }}</div>
                                </li>
                                <li class="monitoring_content_item">
                                    <span>监测范围：</span>
                                    <div class="item_content">
                                        <span v-for="(item,index) in scopes" class="range">{{ item }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="monitoring_law_box">
                        <ul class="monitoring_law_group">
                            <li class="monitoring_law_item">
                                <img class="law_item_img" src="./images/determine.png" alt="">
                                <router-link to="/lawJudgement" class="btn_big small">进行侵权判定</router-link>
                            </li>
                            <li class="monitoring_law_item">
                                <img class="law_item_img" src="./images/letter.png" alt="">
                                <router-link to="/lawIssue" class="btn_big small">出具律师函</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import monitorItem from "@/views/vipClip/monitor/components/monitorItem";
    import {_getContent} from "@/api/monitor.js";
    import countTo from 'vue-count-to';


    export default {
        metaInfo: {
            title: '监测中|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        name: "monitoring",
        components: {
            monitorItem,
            countTo
        },
        data() {
            return {
                timer: null,
                monitorId: '',
                platfromNumber: '', //监测平台数据
                monitorNumber: '', //已监测数据
                spreadNumber: '', //监测结果的数量
                platformsTotal: '', //监测平台结果数量
                platforms: [], //监测结果
                platformsCache: [], //监测结果缓存，为了数字增加的起始值
                monitorData: [], //部分监测结果数据
                scopes: [], //监测范围
                monitorName: '', //监测名称
                monitorType: '', //监测类型
                monitorState: '', //监测状态
                reportUrl: '', //监测报表
                textIcon: require('@/assets/text_small_icon.png'),
                musicIcon: require('@/assets/music_small_icon.png'),
                fileIcon: require('@/assets/file_small_icon.png'),
                workImage: '' //监测图片


            }
        },
        created() {
            console.log(this.$route.query.id);
            if (this.$route.query.id && this.$route.query.id != '') {
                this.monitorId = this.$route.query.id;
                this.getContent()
            }
        },
        methods: {
            /***************获取监测中数据**************/
            getContent() {
                var that = this;
                that.timer = setInterval(() => {
                    that.getRequest("/copyrightMonitorContent/getContent/" + that.monitorId).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            const oldPlatforms = this.platforms;
                            let result = res.result;
                            this.platfromNumber = result.platfromNumber;
                            this.monitorNumber = result.monitorNumber;
                            this.spreadNumber = result.spreadNumber;
                            this.platformsTotal = (result.total ? result.total : 0);
                            this.platforms = (result.platforms ? result.platforms : []);
                            this.monitorData = (result.monitorData ? result.monitorData : []);
                            this.scopes = result.scopes;
                            this.monitorName = result.monitorName;
                            this.monitorType = result.type;
                            this.monitorState = result.status;
                            this.workImage = result.workImage;
                            this.reportUrl = result.reportUrl;

                            if (oldPlatforms.length != 0) {
                                for (let i = 0; i < this.platforms.length; i++) {
                                    for (let j = 0; j < oldPlatforms.length; j++) {
                                        if (this.platforms[i].title == oldPlatforms[j].title) {
                                            this.platforms[i].monitorNumberStart = oldPlatforms[j].monitorNumber;
                                            this.platforms[i].spreadNumberStart = oldPlatforms[j].spreadNumber;
                                        }
                                    }
                                }
                            }

                            if (result.status == 2) {
                                clearInterval(this.timer);
                                this.timer = null
                            }


                        }
                    });
                }, 1000)

            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
            this.timer = null
        }
    }
</script>

<style scoped lang="less">
    ol, ul {
        list-style: none;
    }

    .container {
        width: 1334px;
        margin: 0 auto;
        overflow: hidden;
    }

    .monitoring .monitoring_box {
        display: flex;
        justify-content: space-between;
    }

    .monitoring_box .monitoring_box_left {
        width: 890px;

    }

    .monitoring_box .monitoring_box_right {
        width: 424px;
    }

    .monitoring_box_left .photo_box {
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .title_group {
        padding: 15px 30px 15px 17px;
        background: #fff;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px 2px 0 0;
        display: flex;
        font-size: 14px;
        color: #333;
        justify-content: space-between;
    }

    .title_group .subheading {
        padding-left: 10px;
        color: #999999;
    }

    .gray_btn {
        width: 84px;
        height: 33px;
        line-height: 33px;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        text-align: center;
    }

    .gray_btn.small {
        width: 64px;
        height: 29px;
        line-height: 29px;
        font-size: 12px;
        color: #333333;
    }

    .gray_btn:hover {
        background: rgba(18,18,16,1);
        color:#fff;
        border: 1px solid rgba(18,18,16,1);
    }

    .photo_main .fan_chart {
        width: 300px;
        height: 174px;
        background: url(./images/fan_chart.png) no-repeat left center;
        background-size: 100% 100%;
        margin: 50px auto;
        position: relative;
    }

    .fan_chart .circular {
        width: 55px;
        height: 55px;
        border-radius: 50%;
        box-shadow: 0 1px 10px 0 rgba(121, 128, 178, 0.14);
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -27.5px;
        text-align: center;
        font-size: 14px;
        color: #525252;
        line-height: 55px;
    }

    .fan_chart .circular_desc {
        position: absolute;
        bottom: -30px;
        left: 50%;
        transform: translate(-50%, 0);
        color: #525252;
        font-size: 14px;
    }

    .fan_chart .tips_box {
        box-shadow: -8px 10px 45px 0 rgba(121, 128, 178, 0.08);
        border-radius: 28px;
        padding: 13px 15px;
        font-size: 14px;
        color: #333;
        background: rgba(255, 255, 255, 1);
        position: absolute;
        white-space: nowrap;
    }

    .tips_box.platform {

        top: 31px;
        right: 233px;

        .tips_name:before {
            content: '';
            padding-left: 31px;
            height: 19px;
            background: url(./images/platform.png) no-repeat left center;
            background-size: 22px 19px;
            display: inline-block;
            vertical-align: text-bottom;
        }
    }

    .tips_box.data {

        top: -32px;
        left: 142px;

        .tips_name:before {
            content: '';
            padding-left: 28px;
            height: 20px;
            background: url(./images/data.png) no-repeat left center;
            background-size: 18px 20px;
            display: inline-block;
            vertical-align: text-bottom;
        }
    }

    .tips_box.time {

        top: 68px;
        left: 254px;

        .tips_name:before {
            content: '';
            padding-left: 30px;
            height: 20px;
            background: url(./images/time.png) no-repeat left center;
            background-size: 20px 20px;
            display: inline-block;
            vertical-align: text-bottom;
        }
    }

    .monitoring_box_left .result_box {
        margin-top: 20px;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .monitoring_box_left .partial_result_box {
        margin-top: 20px;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .partial_result_main .partial_result_group {
        padding: 20px 20px 0;
        display: flex;
        flex-wrap: wrap;

    }

    .partial_result_group .result_item {
        margin: 0 10px 20px 0;
    }

    .partial_result_group .partial_result_item:nth-child(4n) {
        margin-right: 0;
    }

    .monitoring_box_left .legal_introduction {
        margin: 20px 0 60px;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
    }

    .legal_introduction .legal_introduction_title {
        padding-top: 36px;
        color: #040404;
        font-weight:500;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: 2px;
        width: 247px;
        margin: 0 auto;
        text-align: center;
    }

    .legal_introduction .legal_introduction_group {
        padding-top: 21px;
        margin: 0 98px;
        display: flex;
        flex-wrap: wrap;
    }

    .legal_introduction_group .legal_introduction_item {
        width: 50%;
        margin-bottom: 40px;
        font-size: 18px;
        line-height: 25px;
        font-weight: 400;
        color: #333;
    }

    .legal_introduction_item .legal_introduction_item_title {
        margin-bottom: 10px;
        position: relative;
    }

    .legal_introduction_item_title .item_title_num {
        font-size: 18px;
        font-weight: bold;
    }

    .legal_introduction_item_title .item_title_desc {

        position: absolute;
        font-size: 12px;
        color: #999999;
        /*padding-left: 3px;*/
        top: 15px;
        background: #fff;
        line-height: 1;
        vertical-align: top;
    }

    .item_title_desc .desc_msg {
        position: relative;
        line-height: 1;
    }

    .item_title_desc .desc_msg:after {
        content: '';
        position: absolute;
        left: -3px;
        width: 80px;
        height: 7px;
        background: #FAFAFA;
        z-index: -1;
    }

    .item_title_desc .desc_transverse {
        width: 80px;
        height: 7px;
        background: #FAFAFA;
    }

    .legal_introduction .legal_introduction_btn {
        display: flex;
        width: 401px;
        margin: 0 auto;
        justify-content: space-between;
        padding-bottom: 30px;
    }

    .monitoring_box_right .monitoring_content_box {
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .monitoring_content_box .monitoring_content_title {
        width: 100%;
        height: 62px;
        line-height: 62px;
        font-size: 16px;
        color: #333333;
        background: #fff;
        border-bottom: 1px solid #EEEEEE;
        padding-left: 20px;
        box-sizing: border-box;
    }

    .monitoring_content_box .monitoring_content_msg {
        padding: 20px;
    }

    .monitoring_content_msg .monitoring_content_msg_img_box {
        width: 384px;
        height: 184px;
        background: #fcfcfc;
        display: flex;
        border-radius: 6px;
    }

    .monitoring_content_msg_img_box .monitoring_content_msg_img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        display: block;
        object-fit: cover;
    }

    .monitoring_content_msg_img_box .partial_result_img_icon {
        width: 50px;
        height: 42px;
        display: block;
        align-self: center;
        margin: 0 auto;
    }

    .monitoring_content_msg .monitoring_content_group {
        padding: 20px 0 53px;
        font-size: 14px;
        color: #333;
    }

    .monitoring_content_group .monitoring_content_item {
        padding-bottom: 10px;
        display: flex;
    }

    .monitoring_content_item .item_content {
        flex: 1;
        padding-left: 5px;
    }

    .item_content .range {
        padding: 0 10px 10px 0;
        display: inline-block;
    }

    .monitoring_box_right .monitoring_law_box {
        margin-top: 20px;
    }

    .monitoring_law_box .monitoring_law_group {
        display: flex;
        justify-content: space-between;
    }

    .monitoring_law_group .monitoring_law_item {
        width: 207px;
        height: 202px;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 2px;
    }

    .monitoring_law_item .law_item_img {
        margin: 40px auto 37px;
        display: block;
        width: 108px;
        height: 77px;
    }


    .btn_group {
        padding: 30px 0;
        text-align: center;
    }

    .btn_big {
        width:152px;
        height:42px;
        line-height: 42px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background:rgba(18,18,16,1);
        display: inline-block;
        cursor: pointer;
    }

    .btn_big.small {
        width: 124px;
        height:33px;
        line-height: 33px;
        background: transparent;;
        border:1px solid rgba(18,16,0,1);
        font-size:12px;
        color:rgba(18,18,16,1);
        display: block;
        margin: 0 auto;
    }
    .btn_big.bigBtn{
        width:218px;
    }
    .monitor_complete {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: sub;
        margin-right: 10px;
    }

    /*动画效果*/
    .rotate_loading {
        width: 21px;
        height: 20px;
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
        /*margin: 20px auto;*/
        /*animation (动画) :绑定选择器, 4s完成动画 linear(匀速) infinite(循环) */
        animation: loading 1.5s linear infinite;
    }


    /*通过@keyframes规则,能够创建动画 , que 定义动画的名称 可自己定义*/
    @keyframes loading {
        /*以百分比来规定改变发生的时间 也可以通过"from"和"to",等价于0% 和 100%*/
        0% {
            /*rotate(2D旋转) scale(放大或者缩小) translate(移动) skew(翻转)*/
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

</style>